/**
 * Auction Hub Card — Fav Star handling
 * Extracted from auction-hub-card.liquid
 *
 * Reads bidder number from #ProductGridContainer data-bidder-number attribute.
 */
(function() {
  'use strict';

  // Handle favorite star clicks - prevent click from going to product link
  window.handleFavClick = function(event, productId) {
    event.favStarHandled = true;
  };

  // Helper function: show a floating message above the star that fades upward.
  function showFavMessage(star, message) {
    var msgEl = document.createElement('div');
    msgEl.innerText = message;
    msgEl.style.position = 'absolute';
    msgEl.style.bottom = '100%';
    msgEl.style.left = '50%';
    msgEl.style.transform = 'translateX(-50%)';
    // The heart's red on a pale red, whatever the theme (it was theme text on a
    // theme surface, which on the dark card photo read dark-on-dark).
    msgEl.style.backgroundColor = '#FFE9EF';
    msgEl.style.color = 'var(--mhv-fav)';
    msgEl.style.border = '1px solid var(--mhv-fav)';
    msgEl.style.fontWeight = '700';
    msgEl.style.padding = '4px 8px';
    msgEl.style.fontSize = '12px';
    msgEl.style.borderRadius = '3px';
    msgEl.style.opacity = '1';
    msgEl.style.pointerEvents = 'none';
    msgEl.style.transition = 'all 2s ease-out';
    msgEl.style.whiteSpace = 'nowrap';
    star.appendChild(msgEl);

    setTimeout(function() {
      msgEl.style.transform = 'translate(-50%, -30px)';
      msgEl.style.opacity = '0';
    }, 500);

    setTimeout(function() {
      if (star.contains(msgEl)) {
        star.removeChild(msgEl);
      }
    }, 2050);
  }

  function updateStarUI(star, faved) {
    var icon = star.querySelector('.star-icon');
    if (faved) {
      star.setAttribute('data-faved', 'true');
      // Heart red — the colour lives in mhv-theme-vars.css, nowhere else.
      icon.setAttribute('fill', 'var(--mhv-fav)');
      icon.setAttribute('stroke', 'var(--mhv-fav)');
      star.setAttribute('title', 'Remove from Favs');
    } else {
      star.setAttribute('data-faved', 'false');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', '#fff');
      star.setAttribute('title', 'Add to Favs');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (window.favEventAttached) return;
    window.favEventAttached = true;

    var productGrid = document.getElementById('ProductGridContainer');
    if (!productGrid) return;

    var bidderNumber = productGrid.getAttribute('data-bidder-number') || '';

    productGrid.addEventListener('click', function(event) {
      var star = event.target.closest('.fav-star');
      if (!star) return;

      event.stopPropagation();
      event.preventDefault();

      var productId = star.getAttribute('data-product-id');
      var favTag = bidderNumber + '-favs';
      var currentlyFaved = star.getAttribute('data-faved') === 'true';
      var isAdding = !currentlyFaved;

      // Optimistic update
      updateStarUI(star, isAdding);
      showFavMessage(star, isAdding ? 'Added to Favs!' : 'Removed from Favs');
      if (window.optimisticFavUpdate) {
        window.optimisticFavUpdate(productId, isAdding);
      }

      console.log('Sending fav tag update for product:', productId, 'with favTag:', favTag);

      mhvFetch(MHV.SERVER_URL + '/update-fav-tag', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId, fav_tag: favTag })
      })
      .then(function(response) {
        console.log('Response status:', response.status);
        return response.json();
      })
      .then(function(data) {
        console.log('Response data:', data);
        if (data.success) {
          console.log('Favorite update confirmed by server');
          if (data.updated_fav_count !== undefined && window.updateFavCountDisplay) {
            setTimeout(function() {
              window.updateFavCountDisplay(productId, data.updated_fav_count);
            }, 100);
          }
        } else {
          console.error('Failed to update product tag:', data);
          updateStarUI(star, currentlyFaved);
          if (window.optimisticFavUpdate) {
            window.optimisticFavUpdate(productId, currentlyFaved);
          }
        }
      })
      .catch(function(error) {
        console.error('Error:', error);
        updateStarUI(star, currentlyFaved);
        if (window.optimisticFavUpdate) {
          window.optimisticFavUpdate(productId, currentlyFaved);
        }
      });
    });
  });
})();
